export const RESET_METRIC_TYPES = 'RESET_METRIC_TYPES'
export const RESET_METRIC_TYPES_SEARCH = 'RESET_METRIC_TYPES_SEARCH'
export const SET_METRIC_TYPES = 'SET_METRIC_TYPES'
export const SET_METRIC_TYPES_SEARCH = 'SET_METRIC_TYPES_SEARCH'
